import { getTranslatedText, getDateTimeFormat } from '@nile/components';
import { cloneDeep } from 'lodash';
import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { Button, Checkbox, TimePicker } from '@superops/ui-design-system';

const format = 'h:mm a';

const DurationTable = styled.table`
  margin: 0px 18px;
  max-width: 560px;
  .bhtime-0:hover {
    .hidden-action {
      visibility: visible;
    }
  }
  .hidden-action {
    visibility: hidden;
  }
  .value_selector__control {
    min-width: 52px;
  }
  thead {
    background-color: white;
    box-shadow: none;
  }
  thead > tr {
    background: rgba(0, 0, 0, 0.05);
  }
  th {
    background-color: white;
    padding: 10px 8px 0;
    text-transform: lowercase;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: black;
    &::first-letter {
      text-transform: capitalize;
    }
  }
  td {
    padding: 0;
  }
  tr {
    height: 40px;
  }
`;

const StyledTimePicker = styled(TimePicker)`
  .rc-time-picker-input {
    width: 120px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0;
    color: #000;
    font-size: 14px;
    outline: none !important;
  }
`;

function WorkingHours(props) {
  const { intl, businessHours } = props;

  const { MSPtimeFormat } = getDateTimeFormat();

  const userTimeFormat = props?.currentTimeFormat || MSPtimeFormat || format;

  const is12HoursFormat = userTimeFormat === 'HH:mm' ? false : true;

  const hours = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' }
  ];
  const hourType = [
    { label: 'AM', value: 'AM' },
    { label: 'PM', value: 'PM' }
  ];
  const getBusinessHours = () => {
    const days = [
      {
        label: getTranslatedText(intl, 'client.new.workingtime.mon'),
        day: 'MONDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'MONDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.tue'),
        day: 'TUESDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'TUESDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.wed'),
        day: 'WEDNESDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'WEDNESDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.thu'),
        day: 'THURSDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'THURSDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.fri'),
        day: 'FRIDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'FRIDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.sat'),
        day: 'SATURDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'SATURDAY'
      },
      {
        label: getTranslatedText(intl, 'client.new.workingtime.sun'),
        day: 'SUNDAY',
        start: '',
        end: '',
        startHourType: hourType[0],
        endHourType: hourType[1],
        checked: false,
        name: 'SUNDAY'
      }
    ];
    if (businessHours && businessHours.length) {
      businessHours.forEach((el) => {
        const idx = days.findIndex((d) => d.day === el.day);
        days[idx] = {
          ...days[idx],
          start: el.start.toString(),
          end: el.end.toString(),
          checked: true
        };
      });
    }
    return days;
  };

  const [rows, setRows] = useState(getBusinessHours());
  useEffect(() => {
    setRows(getBusinessHours());
  }, [businessHours]);
  const handleTimeSelection = (day, key, val) => {
    const newRows = cloneDeep(rows);
    const index = newRows.findIndex((el) => el.day === day);
    newRows[index] = {
      ...rows[index],
      [key]: val
    };
    setRows(newRows);
    props.handleChange(newRows[index]);
  };
  const copyWorkingHours = () => {
    props.copyWorkingHours();
  };
  return (
    <DurationTable className="business-day-table">
      <thead>
        <tr>
          <th>
            <FormattedMessage id="client.new.workingtime.Workdays" />
          </th>
          <th>
            <FormattedMessage id="client.new.workingtime.starthour" />
          </th>
          <th>
            <FormattedMessage id="client.new.workingtime.endhour" />
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((item, index) => (
          <tr className={`bhtime-${index}`} key={`bhtime-${index}`}>
            <td>
              <Checkbox
                label={item.label}
                checked={item.checked}
                onChange={handleTimeSelection.bind(this, item.day, 'checked')}
              />
            </td>
            <td>
              <StyledTimePicker
                showSecond={false}
                value={
                  item.start
                    ? moment(item.start, is12HoursFormat ? 'HH:mm a' : 'HH:mm')
                    : null
                }
                className="xxx"
                onChange={(args) => {
                  const time = args ? args.format('HH:mm') : '';
                  handleTimeSelection(item.day, 'start', time);
                }}
                format={userTimeFormat}
                use12Hours={is12HoursFormat}
                minuteStep={15}
                inputReadOnly
                popupClassName="super-time-picker"
                placeholder={getTranslatedText(
                  intl,
                  'client.new.workingtime.time'
                )}
              />
            </td>
            <td>
              <div className="fx">
                <StyledTimePicker
                  showSecond={false}
                  value={
                    item.end
                      ? moment(item.end, is12HoursFormat ? 'HH:mm a' : 'HH:mm')
                      : null
                  }
                  className="xxx"
                  onChange={(args) => {
                    const time = args ? args.format('HH:mm') : '';
                    handleTimeSelection(item.day, 'end', time);
                  }}
                  format={userTimeFormat}
                  use12Hours={is12HoursFormat}
                  minuteStep={15}
                  inputReadOnly
                  popupClassName="super-time-picker"
                  placeholder={getTranslatedText(
                    intl,
                    'client.new.workingtime.time'
                  )}
                />
              </div>
            </td>
            {index === 0 ? (
              <td>
                <div className="hidden-action">
                  <Button
                    id="copyWorkingHours"
                    onClick={copyWorkingHours}
                    plain
                  >
                    Copy
                  </Button>
                </div>
              </td>
            ) : (
              ''
            )}
          </tr>
        ))}
      </tbody>
    </DurationTable>
  );
}

export default injectIntl(WorkingHours);
